module.exports = __webpack_public_path__ + "static/MyMango-fa5365df7d4bd995bd7f1efa21d0cd8e.png";